import { render } from "./siteWrapper.vue?vue&type=template&id=8c779bc4"
import script from "./siteWrapper.vue?vue&type=script&lang=js"
export * from "./siteWrapper.vue?vue&type=script&lang=js"

import "./siteWrapper.vue?vue&type=style&index=0&id=8c779bc4&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_webpack@5.111.1_postcss@8.5.29_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__